module.exports = __webpack_public_path__ + "static/media/3DPPA38.53f58f29.jpg";